"use client"

import { Button, Col, Divider, Row } from "antd"
import { CSSProperties, FC, ReactNode } from "react"
import ArrowLeftIcon from "@/components/icons/ArrowLeftIcon"
import SearchIcon from "@/components/icons/SearchIcon"
import Title from "../Typography/Title"
import { debounce } from "lodash"

export type PageHeaderMobileProps = {
  title?: ReactNode,
  leftIcon?: ReactNode,
  onLeftClick?: () => void,
  shownLeft?: boolean,

  rightIcon?: ReactNode,
  rightContent?: ReactNode,
  onRightClick?: () => void,
  shownRight?: boolean,

  bottom?: ReactNode
  className?: string,

  style?: CSSProperties
}

const PageHeaderMobile = ({
  title,
  leftIcon,
  rightIcon,
  rightContent,
  onLeftClick,
  onRightClick,
  shownRight = true,
  shownLeft = true,
  bottom,
  className,
  style
}: PageHeaderMobileProps) => {
  return (
    <Row style={{ ...style }} wrap={false} align='middle' justify='space-between' className={`page__header${className ? ` ${className}` : ''}`}>
      <Col span={24}>
        <Divider style={{ margin: 0 }} />
        <Row style={{ width: '100%' }} gutter={[15, 15]} wrap={false} align='middle' justify='space-between' className="page__header--top">
          <Col>
            {shownLeft && (
              <Button
                onClick={debounce(() => onLeftClick && onLeftClick(), 300)}
                className="page__header--left"
                type='text'
                size='large'
                icon={leftIcon || <ArrowLeftIcon />}
              />
            )}
          </Col>
          <Col flex="1 1 auto" className="page__header--title">
            {typeof title === 'string' ? (
              <Title level={5} style={{ margin: 0 }}>
                {title}
              </Title>
            ) : (
              <>
                {title}
              </>
            )}
          </Col>
          {shownRight && (
            <Col>
              {rightContent || (
                <Button
                  onClick={debounce(() => onRightClick && onRightClick(), 300)}
                  className="page__header--right"
                  type='link'
                  size='large'
                  icon={rightIcon || <SearchIcon />}
                />
              )}
            </Col>
          )}

        </Row>
        {bottom}
        <Divider style={{ margin: 0 }} />
      </Col>
    </Row>
  )
}

export default PageHeaderMobile